export default __webpack_public_path__ + "static/media/059-emergency diversion.286133f6.png";